import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

const flexColumn = {
  display: "flex",
  flexDirection: "column",
};

export const ReferencedNetworkContainer = styled.section(({ theme }) => ({
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",
  borderBottom: `4px solid ${theme.color.line.medium}`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const ReferencedNetworkContent = styled.div(() => ({
  ...flexColumn,
  gap: "32px",
}));

export const ReferencedNetworkHeader = styled.div(() => ({
  ...flexColumn,
  gap: "24px",
}));

export const ReferencedNetworkTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const ReferencedNetworkDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));

export const ReferencedNetworkFooter = styled.div(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),

  a: {
    ...DefaultParagraphLargeFactory({ theme }),
    color: theme.color.brandPrimary.light,
  },
}));

export const ReferencedNetworkIframeWrapper = styled.div(({ theme }) => ({
  margin: "0 auto",
  width: "100%",
  overflow: "auto",

  [theme.breakpoint.lg()]: {
    paddingLeft: "112px",
    paddingRight: "112px",
  },

  iframe: {
    border: "none",
    width: "900px",
    height: "690px",

    [theme.breakpoint.lg()]: {
      width: "100%",
      height: "700px",
    },
  },
}));
